import { jsx as e, jsxs as m } from "react/jsx-runtime";
import { normalizeSocialLink as n } from "../../utils/normalize-social-link.mjs";
import { getSocialLinkIcon as i } from "../../utils/get-social-link-icon.mjs";
import g from "../../../components/store-image.mjs";
import { useStore as s } from "../../../store/index.mjs";
import { StoreImageEnum as d } from "../../../enums/store-image-enum.mjs";
const u = ({ profile: r, socialLinks: l }) => {
  var o;
  const { locale: a } = s();
  return /* @__PURE__ */ e(
    "section",
    {
      role: "region",
      "aria-labelledby": "region-heading",
      style: {
        backgroundImage: (o = r.sellerPhoto) != null && o.path ? `url(${r.sellerPhoto.path})` : void 0
      },
      className: " bg-center-left w-full overflow-hidden bg-contain bg-no-repeat sm:max-w-xl sm:rounded-lg sm:bg-[length:50%_120%]",
      children: /* @__PURE__ */ m(
        "div",
        {
          className: `
          from-THEME-primary min-[460px]:from-78% from-70% min-[460px]:bg-[length:78%] min-[500px]:from-80% min-[500px]:bg-[length:80%] sm:from-70% flex
          min-h-[215px] bg-gradient-to-l 
          to-[transparent] bg-[length:70%] 
          bg-right bg-no-repeat 
          p-5 sm:bg-[length:73%]
        `,
          children: [
            !r.sellerPhoto && /* @__PURE__ */ e("div", { className: "border-3 border-THEME-primary my-auto rounded-full", children: /* @__PURE__ */ e(
              g,
              {
                className: "rounded-full border-0 border-transparent",
                width: 104,
                height: 104,
                alt: r.sellerName,
                imageType: d.profile
              }
            ) }),
            /* @__PURE__ */ m("div", { className: "my-auto ml-auto flex w-[60%] flex-col", children: [
              /* @__PURE__ */ e(
                "h1",
                {
                  id: "region-heading",
                  lang: a,
                  className: "text-THEME-text-primary mb-1 break-all text-left text-[22px] font-medium leading-[26.82px]",
                  children: r.sellerName
                }
              ),
              /* @__PURE__ */ e(
                "span",
                {
                  lang: a,
                  className: "text-THEME-text-primary hyphens-auto mb-2.5 text-left text-lg font-normal",
                  children: r.bio
                }
              ),
              !!l.length && /* @__PURE__ */ e("div", { className: "justify-left z-1 flex flex-wrap items-center gap-1.5", children: l.map((t) => /* @__PURE__ */ e(
                "a",
                {
                  href: n(t),
                  target: "_blank",
                  rel: "noreferrer",
                  className: "bg-THEME-secondary rounded-full p-2",
                  "aria-label": t.type,
                  children: i(t.type, "fill-THEME-primary")
                },
                t.type
              )) })
            ] })
          ]
        }
      )
    }
  );
};
export {
  u as ProfileCosmopolitan
};
